(function () {
  var from = ['rugsy', '66', '@', 'gmail.com'].join('');
  var to = 'support@rugritual.com';
  function swap(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href*="' + from + '"]').forEach(function (a) {
      a.href = a.href.split(from).join(to);
      if ((a.textContent || '').indexOf(from) !== -1) {
        a.textContent = a.textContent.split(from).join(to);
      }
    });
    root.querySelectorAll('.shopify-policy__body, .rte, main').forEach(function (el) {
      if ((el.innerHTML || '').indexOf(from) !== -1) {
        el.innerHTML = el.innerHTML.split(from).join(to);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      swap(document);
    });
  } else {
    swap(document);
  }
})();
